export const intersection = (a, b) => (a.filter(x => b.includes(x)))
export const difference = (a, b) => (a.filter(x => !b.includes(x)))
export const symmetricDifference = (a, b) => (a.filter(x => !b.includes(x))).concat(b.filter(x => !a.includes(x)))
export const union = (a, b) => Array.from(new Set([...a, ...b]))
export const isSuperset = (a, b) => intersection(a, b).length === b.length
